export default "__VITE_ASSET__iFqpcr6m__"